@for (location of locationItems; track location.title) {
    <div class="flex flex-col text-primary-text-color">
        @if (showSales()) {
            <span class="text-small-medium text-dark" i18n>SALES</span>
            <hr class="my-15px border border-solid border-primary-text-color" />
        }
        <a
            [href]="'https://www.google.com/maps/search/?api=1&query=' + location.title"
            target="_blank"
            [attr.aria-label]="'Open Google Maps for ' + location.title"
            [class]="
                ['text-dark', showSales() ? 'text-h5-semi-bold' : 'text-h6-semi-bold']
                    | joinClassNames
            "
            >{{ location.title }}</a
        >
        <span [class]="showSales() ? 'text-medium-regular' : 'text-medium-bold'">
            {{ currentTime() | date: 'HH:mm:ss (z)' : location.timeZone }}
        </span>
        @if (showSales()) {
            <a
                class="text-large-medium"
                [href]="'mailto:' + salesEmail"
                [attr.aria-label]="'Send an email to ' + salesEmail"
                >{{ salesEmail }}</a
            >
        }
    </div>
}
